// start:ng42.barrel
export * from './species.facade';
export * from './species.model';
// end:ng42.barrel

